import React from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import CountUp from "react-countup";

const PollOverlay = (props) => {
  const { pollOptions } = props.overlayStore;
  const sum = pollOptions
    .reduce((s, result) => +result.amount_raised.value + s, 0)
    .toFixed(2);

  const sumValCheck = sum > 0 ? "poll" : "poll poll-zero";

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const percentage = urlParams.get("percentage");
  const dollar = urlParams.get("dollar");
  const color = urlParams.get("color");

  return (
    <div className="poll_options cf">
      {pollOptions.map((option) => (
        <div
          className={sumValCheck + " " + color}
          key={option.id}
          style={{
            width: `${
              parseFloat(option.amount_raised.value) === 0
                ? 0
                : Math.round(
                    100 *
                      (parseFloat(option.amount_raised.value) / parseFloat(sum))
                  )
            }%`,
          }}
        >
          <p>
            {dollar === "yes" ? (
              <span>
                $
                <CountUp
                  end={Number(option.amount_raised.value)}
                  duration={1}
                  separator=","
                  decimals={0}
                  preserveValue={true}
                  useEasing={false}
                />
              </span>
            ) : (
              ""
            )}
            {percentage === "yes" && dollar === "yes" ? " - " : ""}
            {percentage === "yes" ? (
              <span>
                <CountUp
                  end={
                    parseFloat(Number(option.amount_raised.value)) <= 0
                      ? 0
                      : Math.round(
                          100 *
                            (parseFloat(Number(option.amount_raised.value)) /
                              parseFloat(sum))
                        )
                  }
                  duration={1}
                  separator=","
                  decimals={0}
                  preserveValue={true}
                  useEasing={false}
                />
                %
              </span>
            ) : (
              ""
            )}{" "}
            {option.name}
          </p>
        </div>
      ))}
    </div>
  );
};

export default inject("overlayStore")(observer(PollOverlay));
